import styled from 'styled-components';

import {border, buttonReset, colors, font} from 'theme';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    height: auto;
`;

export const Headline = styled.h1`
    color: #939aa4;
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    text-align: center;
    margin: 0;
    padding: 0;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const SelectedCount = styled.div`
    box-sizing: border-box;
    padding: 10px 16px;
    display: flex;
    justify-content: center;
    width: fit-content;
    min-width: 113px;
    height: auto;
    min-height: 44px;
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0;

    color: #5658d8;
    background-color: #f4f5ff;
    border-radius: ${border.radius};
`;

export const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 380px;
    overflow-y: auto;
`;

export const ListItem = styled.li`
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0;
    color: ${colors.textPrimary};
    padding: 8px 16px;
`;
